import styled from 'styled-components';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Dropdown = styled(Row)`
  width: 100%;
  border-top: 1px solid gray;
  margin-top: 40px;
  padding-top: 40px;
  align-items: flex-start;
  justify-content: space-between;
  label {
    color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N800
        : props.theme.atlas.semantic.color.type.default} !important;
    font-size: 16px !important;
    font-weight: 500 !important;
  }
`;

export const CheckboxWithTitle = styled(Row)`
  margin-left: 8px;
`;

export const SCIMContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
`;
